<template>
  <div>
    <div class="ra-page--section">
      <el-row type="flex">
        <el-col :span="24">
          <h6>History</h6>
        </el-col>

        <el-col :span="76">
          <csv-format
            :disabled="!dataFound"
            :download-api-details="downloadApiDetails"
          />
        </el-col>
      </el-row>
    </div>
    <el-row type="flex">
      <el-col :span="24">
        <ra-card>
          <template slot="header">
            <div class="w-100 is-flex is-align-center is-justify-between mb-2">
              <el-select
                clearable
                v-model="filters.activityType"
                class="mr-1"
                placeholder="Activity"
                size="medium"
              >
                <el-option
                  v-for="(field, index) in activityTypes"
                  :key="index"
                  :label="field.name"
                  :value="field.id"
                ></el-option>
              </el-select>
              <el-select
                clearable
                v-model="filters.isCredit"
                class="mr-1"
                placeholder="Transaction Type"
                size="medium"
              >
                <el-option
                  v-for="(field, index) in transactionTypes"
                  :key="index"
                  :label="field.name"
                  :value="field.value"
                ></el-option>
              </el-select>
              <el-date-picker
                class="mr-1"
                v-model="filters.startDate"
                value-format="yyyy-MM-dd"
                placeholder="Start Date"
                size="medium"
              />
              <el-date-picker
                class="mr-1"
                v-model="filters.endDate"
                value-format="yyyy-MM-dd"
                placeholder="End Date"
                size="medium"
              />
              <el-button
                type="success"
                :loading="loading"
                size="medium"
                :disabled="!filtersFilled"
                @click="filter"
                >Filter</el-button
              >
              <el-button
                type="danger"
                :loading="loadingClear"
                size="medium"
                :disabled="!filtersFilled"
                @click="clearFilter"
                >Clear</el-button
              >
            </div>
          </template>

          <template slot="content">
            <el-table
              :data="pageData"
              v-loading="loading"
              :empty-text="noDataMessage"
            >
              <el-table-column min-width="120">
                <template slot="header">
                  <span class="ra-table--header">
                    Date
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{ mFormatDate(scope.row.done_at, "Do MMM, YYYY") }} -
                    {{ mFormatTime(scope.row.done_at) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column width="100">
                <template slot="header">
                  <span class="ra-table--header">
                    Type
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.is_credit ? "Credit" : "Debit" }}</p>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  <span class="ra-table--header">
                    Activity
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{
                      scope.row.target_type_object &&
                        scope.row.target_type_object.name
                    }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  <span class="ra-table--header">
                    Charge
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ formatPrice(scope.row.amount) }}</p>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header">
                  <span class="ra-table--header">
                    Balance
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ formatPrice(scope.row.balance) }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="comment" min-width="120">
                <template slot="header">
                  <span class="ra-table--header">
                    Comment
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.comment }}</p>
                </template>
              </el-table-column>
            </el-table>
            <ra-pagination
              v-if="dataFound"
              :from="from"
              :to="to"
              :total="total"
              :pageSize="pagination.perPage"
              :current-page.sync="currentPage"
            />
          </template>
        </ra-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { dateRangeValidation, orderBy } from "@/lib/utils";
import CsvFormat from "@/components/Export/CsvFormat";
import apiConstants from "@/apiConstants.js";
import moment from "moment";

const filter = {
  isCredit: null,
  activityType: "",
  startDate: "",
  endDate: ""
};

export default {
  name: "Transactions",

  components: {
    CsvFormat
  },

  data() {
    return {
      loading: false,
      loadingClear: false,
      pageData: [],
      currentPage: 1,
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      filters: { ...filter },
      transactionTypes: apiConstants.TRANSACTION_TYPES,
      activityTypes: [],
      noDataMessage: "No billing(s) available",
      downloadApiDetails: {
        reportFor: "billings",
        method: "GET",
        nameSpace: apiConstants.URLS.PAYMENT
      },
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    },

    filtersFilled() {
      const filters = Object.values(this.filters);
      return !!filters.filter(flt => flt || flt === 0).length;
    }
  },

  methods: {
    getPaginationParams() {
      const { currentPage, pagination } = this;
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },

    filter() {
      const filters = [];
      let filtersValid = true;

      if (this.filters.activityType) {
        filters.push({
          field: "target_type_id",
          value: this.filters.activityType
        });
      }

      if (
        this.filters.isCredit !== undefined &&
        this.filters.isCredit !== null
      ) {
        filters.push({
          field: "is_credit",
          value: Number(this.filters.isCredit)
        });
      }

      if (this.filters.startDate) {
        this.filters.startDate = moment(this.filters.startDate).format(
          "YYYY-MM-DD 00:00:00"
        );
        filters.push({
          field: "done_at",
          value: this.filters.startDate,
          cond_op: ">="
        });
      }
      if (this.filters.endDate) {
        this.filters.endDate = moment(this.filters.endDate).format(
          "YYYY-MM-DD 23:59:59"
        );
        filters.push({
          field: "done_at",
          value: this.filters.endDate,
          cond_op: "<="
        });
      }

      if (this.filters.startDate && this.filters.endDate) {
        const startAt = this.filters.startDate;
        const endAt = this.filters.endDate;
        const isValidRange = dateRangeValidation(startAt, endAt);
        if (!isValidRange) {
          this.notification(
            "Invalid Input",
            "Date range is invalid. End date must be greater than Start date",
            "danger"
          );
          filtersValid = false;
        }
      }

      if (filtersValid) {
        const params = `&filters=${JSON.stringify(filters)}`;
        this.pageData = [];
        this.loadBills(params);
      }
    },

    clearFilter() {
      this.loadingClear = true;
      this.filters = { ...filter };
      this.loadBills();
    },

    loadBills(customParams = "") {
      this.loading = true;
      const params = `&embeds=["target", "targetTypeObject"]${customParams}`;
      const apiUrl = "wallets/histories";
      const sortBy = orderBy("id");

      this.downloadApiDetails.url = apiUrl;
      this.downloadApiDetails.params = `no_pages=1${params}${sortBy}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${params}&${this.getPaginationParams()}${sortBy}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.PAYMENT
            }
          }
        )
        .then(response => {
          this.loading = this.loadingClear = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.pageData = resData.list;
            this.pagination.total = resData.pagination.total_count;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    loadActivityTypes() {
      const apiUrl = "wallets/targets/types";
      const params = `?no_pages=1`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: params
          },
          {
            headers: {
              "data-baseurl-namespace": "public/payments"
            }
          }
        )
        .then(response => {
          this.activityTypes = response.data || [];
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  },

  mounted() {
    this.loadBills();
    this.loadActivityTypes();
  },

  watch: {
    currentPage() {
      this.filter();
    },

    filtersFilled(newVal, oldVal) {
      if (oldVal && !newVal && !this.dataFound) {
        this.loadBills();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
